<template>
  <div>
    <b-row class="pt-2">
      <b-col cols="5">
        <Product v-model="myLineItem.productId" @hasData="hasData" />
        <div v-if="addProduct" class="pt-1">
          <small>
            <a href="#">Add new product : {{ addProduct }} </a>
          </small>
        </div>
      </b-col>
      <b-col>
        <label class="form-control-label" for="example-datepicker">
          <base-input v-model="myLineItem.qty" />
        </label>
      </b-col>
      <b-col>
        <label class="form-control-label" for="example-datepicker">
          <base-input-currency v-model="myLineItem.price" />
        </label>
      </b-col>
      <b-col style="text-align:right">
        <label class="form-control-label" for="example-datepicker">
          {{ total | currency }}
        </label>
      </b-col>
      <b-col>
        <a href="#" @click.prevent="$emit('deleteLineItem', index)">
          <i class="fa fa-trash"></i>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Product from "./Product.vue";
export default {
  components: { Product },
  props: { lineItem: null },
  computed: {
    total() {
      return this.myLineItem.qty * this.myLineItem.price;
    },
  },
  watch: {
    myLineItem: {
      handler(newValue, oldValue) {
        this.$emit("lineItemChanged", newValue);
      },
      deep: true,
    },
  },
  data() {
    return {
      myLineItem: null,

      addProduct: null,
    };
  },
  created() {
    this.myLineItem = JSON.parse(JSON.stringify(this.lineItem));
  },
  methods: {
    hasData(entry) {
      this.addProduct = entry;
    },
  },
};
</script>

<style></style>
